export function mapContentWarnings(contentWarnings) {
  let contentWarningsArray = []
  Object.keys(contentWarnings).forEach(cw => {
    if (Array.isArray(contentWarnings[cw])) {
      // sometimes, like risky_behaviors, key is an array
      contentWarnings[cw].forEach(i => {
        contentWarningsArray.push(i)
      })
    } else {
      contentWarningsArray.push(contentWarnings[cw])
    }
  })

  return contentWarningsArray
}

export function activityHasContentWarnings(activity) {
  return (
    activity.resources &&
    activity.resources.some(r => {
      return Object.keys(r.content_warnings).length > 0
    })
  )
}

export function questHasContentWarnings(quest) {
  return (
    quest.content_warnings && Object.keys(quest.content_warnings).length > 0
  )
}

export function contentWarningsSelectedButNoValues(contentWarnings) {
  return (
    document.getElementById('content-warnings-true') &&
    document.getElementById('content-warnings-true').checked === true &&
    contentWarnings &&
    (Object.keys(contentWarnings).length === 0 ||
      Object.keys(contentWarnings).every(function (cw) {
        return (
          contentWarnings[cw] === '' ||
          !contentWarnings[cw] ||
          contentWarnings[cw].length === 0
        )
      }))
  )
}



// WEBPACK FOOTER //
// ./src/utils/contentwarnings.js